import withErrorBoundary from '../../util/components/ErrorBoundary/withErrorBoundary'
import TagBand from './TagBand'

export default withErrorBoundary(TagBand, { component: 'TagBand' })
